import { render, staticRenderFns } from "./StatTemplateCommonChart.vue?vue&type=template&id=270923e5&"
import script from "./StatTemplateCommonChart.vue?vue&type=script&lang=js&"
export * from "./StatTemplateCommonChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports